import { TestTube, History } from "lucide-react";
import LuxSidebar from "./LuxSidebar";
import { useAuth } from "@/lib/auth";

const NAV = [
  { section: "Collections", to: "/collector",         label: "Today",   icon: TestTube, tid: "collector-nav-today" },
  { section: "Collections", to: "/collector/history", label: "History", icon: History,  tid: "collector-nav-history" },
];

const TABS = [
  { id: "today",   to: "/collector",         label: "Today",   icon: TestTube, tid: "collector-tab-today" },
  { id: "history", to: "/collector/history", label: "History", icon: History,  tid: "collector-tab-history" },
];

export default function CollectorNav({ activeTabId = "today" }) {
  const { profile } = useAuth();
  return <LuxSidebar items={NAV}
    subtitle={profile?.partner_name ? `${profile.partner_name} · Collector` : "Collector Console"}
    footer="Room + patient name only — tests and results are never visible"
    testidPrefix="collector-nav" homePath="/collector"
    tabs={TABS} activeTabId={activeTabId} />;
}
